export const createHighImpactTargetingApi = ({ callGetApi }) => ({
    getHighImpactPackages(accountId) {
        return callGetApi(`/${accountId}/high_impact_package_targeting`);
    },
});
